@if (showLoader) {
  <mat-progress-bar
    mode="indeterminate"
    color="accent"
  ></mat-progress-bar>
}

<itfg-toolbar
  [collapsed]="!leftSidenav.opened"
  [mode]="navigationMenuMode"
  (searchEvent)="searchClicked($event)"
  [toggleLeftSideNav]="toggleLeftSideNav"
  flex
  >
  <itfg-navigation-menu
    [routes]="config"
    [drawerMode]="drawerMode"
    [collapsed]="true"
  ></itfg-navigation-menu>
</itfg-toolbar>

<mat-sidenav-container autosize>
  <mat-sidenav
    #leftSidenav
    [autoFocus]="true"
    mode="side"
    hasBackdrop="false"
    position="start"
    class="search-drawer"
    [style.width]="
      drawerMode === 'navigation'
        ? ''
        : drawerMode === 'call-hub'
          ? 'min-content'
          : '20vw'
    "
    style="height: 100%"
    >
    <div class="mat-sidenav-box">
      @switch (drawerMode) {
        @default {
          <itfg-navigation-menu
            [routes]="navMenuRoutes"
            [mode]="navigationMenuMode"
            [drawerMode]="drawerMode"
            [collapsed]="false"
          ></itfg-navigation-menu>
        }
        @case (drawerModeTypes.Search) {
          <itfg-quick-search
            [searchCreditForm]="searchCreditForm"
            (searchEvent)="searchClicked($event)"
            >
          </itfg-quick-search>
        }
        @case (drawerModeTypes.CallHub) {
          <itfg-call-hub></itfg-call-hub>
        }
      }
    </div>
  </mat-sidenav>

  <div class="resize-sidenav-container" (click)="toggleLayout()"></div>

  @if (call || credit || client) {
    <div
      class="right-drawer-trigger"
      (click)="toggleRightDrawer()"
      [class.opened]="rightSidenav?.opened"
    ></div>
  }

  @if (logButtonVisible) {
    <div class="circle-opacity-container">
      <div class="circle-opacity">
        <button
          mat-fab
        [matTooltip]="
          (rightSidenav.opened
            ? 'historyLog.closeEventLog'
            : 'historyLog.openEventLog'
          ) | translate
        "
          matTooltipPosition="left"
          [disabled]="['USER_EVENT_LOG'] | isUnauthorized | async"
          (click)="toggleRightDrawer()"
          >
          <mat-icon>history</mat-icon>
        </button>
      </div>
    </div>
  }

  <mat-sidenav
    #rightSidenav
    class="right-drawer"
    mode="side"
    opened="false"
    hasBackdrop="false"
    position="end"
    >
    @if (
      rightDrawerService.drawer.opened ||
      (rightDrawerService.isInCreditEdit &&
      rightDrawerService.isComponentInitialized)
      ) {
      <itfg-right-drawer></itfg-right-drawer>
    }
  </mat-sidenav>

  <ng-content #main></ng-content>
</mat-sidenav-container>
